module.exports = __webpack_public_path__ + "img/EQUAL.0bf84f72.svg";